import React from 'react';
import * as Yup from 'yup';
import { useFormik } from 'formik';
import {
  Button,
  FormControl,
  TextField,
  Typography
} from '@mui/material';
import { DebounceInput } from 'react-debounce-input';
import { useMutation } from 'react-fetching-library';
import { useSelector } from 'react-redux';

import { submitModuleViewAction } from '../../../services/request';

export const ViewForm = props => {
  const { mutate } = useMutation(submitModuleViewAction);
  const { closeDialog, createViewCallback } = props;
  const { module } = useSelector(state => state.app);
  const { orderFilters, orderHiddenColumns, orderColumnsWidth, orderColumnsSequence } = useSelector(state => state.employeeOrderConfig);

  const validationSchema = Yup.object({
    name: Yup.string().required('To pole nie może być puste')
      .max(50, 'Nazwa nie może mięc najwyżej 50 znaków')

  });

  const initialValues = {
    name: ''
  };

  const handleSubmit = async values => {
    values.module = module;
    values.order_filters = orderFilters;
    values.order_hidden_columns = orderHiddenColumns;
    values.order_columns_width = orderColumnsWidth;
    values.order_columns_sequence = orderColumnsSequence;
    const { error, payload } = await mutate(values, 'POST', null);
    if (!error) {
      console.log(values);
      closeDialog();
      createViewCallback(payload);
    }
  };

  const formik = useFormik({
    initialValues,
    validationSchema,
    onSubmit: values => {
      handleSubmit(values);
    }
  });

  return (
    <form onSubmit={formik.handleSubmit} style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', padding: 30 }}>
      <FormControl>
        <Typography color="primary" variant="h6">
            Nazwa widoku
        </Typography>
        <DebounceInput
          variant="outlined"
          name="name"
          id="name"
          type="text"
          value={formik.values.name}
          onChange={formik.handleChange}
          error={formik.touched.name && Boolean(formik.errors.name)}
          helperText={formik.touched.name && formik.errors.name}
          debounceTimeout={100}
          element={TextField}
          autoFocus
        />
      </FormControl>
      <Button
        color="primary"
        variant="contained"
        type="submit"
        style={{ marginTop: 20 }}
      >
          Zapisz
      </Button>
    </form>
  );
};
